<div class="container">
  <ion-row>
    <ion-col size="12">
      <form [formGroup]="attendanceForm">
        <ion-row class="align-items-center">
          <!-- Search Field -->
          <ion-col size="2">
            <mat-form-field class="mat-height40 mat-input-style w-100">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" formControlName="searchTerm">
            </mat-form-field>
          </ion-col>
  
          <!-- Program Selection -->
          <ion-col size="2">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select " formControlName="selectedProgram">
                <mat-option *ngFor="let program of programList" [value]="program">
                  {{ program }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

          <ion-col size="2">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select" formControlName="selectedStatus">
                <mat-option *ngFor="let status of managerList" [value]="status">
                  {{ status }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col> 
    

          <ion-col size="3">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput type="text" placeholder="Avg job learning score=3.67" class="font_regular fs-12">
            </mat-form-field>
          </ion-col>
  
          <!-- Download Button -->
         
        <ion-col size-sm="2" size-md="3" size-lg="3" size-xs="" class=" pl-10 pt-10 pr-10">
          <div class="center-content float-right">
            <div>
              <button  class="mr-10 Download fs-16 font_semibold  float-right center-content mr-5">
                <img src="././assets/icon/yellowdownload.png" class="downIcon">Download
              </button>
            </div>
          </div>
        </ion-col>
        </ion-row>
      </form>
    </ion-col>
  </ion-row>
  
 

  <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Emp Code</th>
          <th>Emp Name</th>
          <th>Q1</th>
          <th>Q2</th>
          <th>Q3</th>
          <th>Avg. Score by Employee</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let emp of trainingScores">
          <td>{{ emp.empCode }}</td>
          <td>{{ emp.empName }}</td>
          <td *ngFor="let score of emp.scores">{{ score }}</td>
          <td>{{ getEmployeeAverage(emp.scores) }}</td>
        </tr>
  
        <!-- Row for average score per question -->
        <tr>
          <td colspan="2"><b>Avg. question score</b></td>
          <td *ngFor="let avg of getQuestionAverages()"><b>{{ avg }}</b></td>
          <td></td>
        </tr>
  
        <!-- Row for overall program average -->
        <tr>
          <td colspan="5"><b>Avg job behavior score = 3.67</b></td>
          <td><b>{{ getProgramAverage() }}</b></td>
        </tr>
      </tbody>
    </table>
  </div>
  

</div>